import React from "react";

import { Admin, Resource } from "react-admin";

import reducer from "../reducer";

import { myDataProvider } from "../dataProvider/dataProvider";

import { CrewDashboard } from "./pages/dashboard/CrewDashboard";

import CrewRoutes from "./layout/CrewRoutes";
import CrewLayout from "./layout/CrewLayout";

import { TaskList } from "../managerApp/resources/tasks/TaskList";
import { TaskCreate } from "../managerApp/resources/tasks/TaskCreate";
import { TaskEdit } from "../managerApp/resources/tasks/TaskEdit";

import { useThemeState } from "../ThemeStateProvider";
export const CrewApp = ({ adminHistory }) => {
  const { selectedTheme } = useThemeState();

  return (
    <Admin
      disableTelemetry
      title="Transloads.co"
      dashboard={CrewDashboard}
      options={{ authGroups: [] }}
      dataProvider={myDataProvider}
      layout={CrewLayout}
      customRoutes={CrewRoutes}
      customReducers={{ data: reducer }}
      theme={selectedTheme}
      history={adminHistory}
    >
      <Resource
        title={"Tasks"}
        name="tasks"
        list={TaskList}
        edit={TaskEdit}
        create={TaskCreate}
      />
    </Admin>
  );
};
